import { t } from 'i18next'
import { Button, Carousel, DangerousHtml } from 'src/components'
import { financialAmountDisplay } from 'src/utils'

interface Props {
  delay?: number
  onClick?: () => void
  price?: number | string
  images?: string[]
  icon?: any
  title: string
  category?: string
  priceDescription?: string
  className?: string
  label?: string
}
const Card = ({
  title,
  images = [],
  price,
  category = 'aaaaaa',
  delay,
  priceDescription,
  onClick,
  label = t('global.read.more'),
  className,
}: Props) => {
  const classes = [
    'flex',
    'flex-col',
    'max-w-[335px]',
    'min-w-[335px]',
    'border-solid',
    'overflow-hidden',
    'rounded-md',
    'group',
    'transition-all',
    'duration-500',
    'from-white',
    'to-gray-200',
    className,
  ]

  return (
    <div className={classes.join(' ')}>
      <div className='overflow-hidden min-w-full flex-center min-h-[280px]  h-full rounded-md relative'>
        <Carousel images={images} delay={delay} />
        {category && (
          <div className='absolute left-[20px] top-[20px] text-white backdrop-blur-[2px] bg-[rgba(0,0,0,0.2)] rounded-[8px] px-2 py-1'>
            {category}
          </div>
        )}
      </div>
      <div className='w-full p-4 flex flex-col justify-between'>
        <div className='flex flex-col gap-4'>
          <div className='w-full flex justify-between'>
            <div>{title}</div>
            <div>ALL {price}</div>
          </div>
          {/* <div className='text-title text-center min-h-[36px] text-ellipsis ... '>
            {title}
          </div>
          {price && (
            <div className='text-header text-center text-ellipsis overflow-hidden truncate h-[26px]'>
              {`${
                priceDescription && priceDescription
              } ${financialAmountDisplay(price)}`}
            </div>
          )}
          {onClick && (
            <div className='flex w-full'>
              <Button className='w-full' onClick={onClick}>
                {label}
              </Button>
            </div>
          )} */}
        </div>
      </div>
    </div>
  )
}

export default Card
